import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash, faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Button, Card, CardBody, Select, SelectItem } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, FixMobileHeight, FixScreenHeight, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { setDetailParams, setNewEntryMode } from "../../state/orderSlice";
import { isMobile } from "react-device-detect";
import { calculateTotal } from "../../Utility/utility";
import { typographyClasses } from "@mui/material";
import { useModalToast } from "../../components/modalToast/ModalToastContext";


const OrderMaster = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { compCode, salePerData, compName } = useSelector((state) => state.company);
    const { show } = useModalToast()
    const [itemToDelete, setItemToDelete] = useState("")
    const [orderStatus, setOrderStatus] = useState("Pending")
    const [data, setData] = useState([])

    // Fetch shape data
    const {
        data: orderData = [],
        isPending,
        isError,
        mutate: filterData
    } = usePost({
        url: apiRoute.saleOrder.fetch,
        queryKey: "fetchOrderlist",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                console.log(data, "df")
                const _ordStatus = orderStatus || "Pending"
                const filData = data.filter((ele) => ele.status == _ordStatus)
                setData(filData)
            }
            else
                setData([])
        }

    });

    const funLoadData = () => {
        filterData({
            data: {
                comp_code: compCode.join(","),
                bill_type: 'S',
                uid: user.isadmin == 1 ? '' : user.username,
                comp_db: user?.clientDB
            }
        })
    }
    useEffect(() => {
        funLoadData();
    }, [])

    const handleStatusChange = (val) => {
        const _ordStatus = val
        setOrderStatus(_ordStatus)
        if (orderData && orderData.length > 0 && val) {
            const filData = orderData.filter((ele) => ele.status == _ordStatus)
            setData(filData)
        }
        else
            setData(orderData)

    }
    // useEffect(() => {

    //     if (orderData && orderData.length > 0) {
    //         if (orderStatus != "" && orderStatus != null) {
    //             const filData = orderData.filter((ele) => ele.status == orderStatus)
    //             setData(filData)
    //         }
    //         else
    //             setData(orderData)
    //     }
    //     else
    //         setData([])
    // }, [orderStatus, orderData])



    // Delete shape mutation
    const { mutate: fnDelete } = usePost({
        url: apiRoute.saleOrder.deleteEntry,
        queryKey: "deletetypeMaster",
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {

                if (data[0].ref == 1) {
                    show(<div className="text-red-500 bg-red-50 p-2 text-xs">Order can't be delete as it is locked"</div>)
                    setItemToDelete("")
                    return;
                }
                else {

                    setItemToDelete("")
                    funLoadData();
                }
            }
        },
        //successMessage: "Item Group deleted successfully!",
    });

    const exportColumns = [
        {
            name: "Party",
            uid: "PartyName",
        },
        {
            name: "Order No",
            uid: "Ord_No",
        },
        {
            name: "Date",
            uid: "Ord_Date",
            type: COLUMN_TYPE.date
        },
        {
            name: "Ord Qty",
            uid: "Ord_Qty",
        },
        {
            name: "Bal Qty",
            uid: "Bal_Qty",
        },
        {
            name: "Sale Person",
            uid: "SalePerName",
        },

        {
            name: "Status",
            uid: "status",
        },

    ]
    const totalOrdQty = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Ord_Qty",
            }),
        [data]
    )
    const totalBalQty = useMemo(
        () =>
            calculateTotal({
                data: data,
                columnName: "Bal_Qty",
            }),
        [data]
    )
    let downloadDataFooter = {
        Party_Name: "",
        Ord_No: "",
        Date: "",
        Ord_Qty: "Total:" + totalOrdQty,
        Bal_Qty: "Total:" + totalBalQty,
        SalePerName: "",
        Status: ""

    }

    const handleConfirmBox = (data) => {
        if (data) {
            fnDelete({
                data: {
                    comp_code: itemToDelete.compcode,
                    bill_type: itemToDelete.billtype,
                    order_no: itemToDelete.orderno
                }
            });
        }
        else
            setItemToDelete("")
    };

    const handleAddNew = () => {
        dispatch(setNewEntryMode(true));
        dispatch(setDetailParams([]));
        navigate(linksUrl.salesOrder.createEntry);
    };



    const columns = [
        { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
        { name: "Party", uid: "PartyName", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Order No", uid: "Ord_No", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Date", uid: "Ord_Date", sortable: true, align: COLUMN_ALIGN_TYPE.center, type: COLUMN_TYPE.date },
        {
            name: "Ord Qty", uid: "Ord_Qty", sortable: true, align: COLUMN_ALIGN_TYPE.center,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalOrdQty,
            },
        },
        {
            name: "Bal Qty", uid: "Bal_Qty", sortable: true, align: COLUMN_ALIGN_TYPE.center,
            footer: {
                type: FOOTER_TYPE.text,
                label: "Total: ",
                value: totalBalQty,
            },
        },
        // { name: "Amount", uid: "Amount", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Sale Person", uid: "SalePerName", sortable: true, align: COLUMN_ALIGN_TYPE.center },
        { name: "Status", uid: "status", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    ];

    const rowActionBtn = [
        {
            // icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
            icon: <FontAwesomeIcon className="text-white  " style={{ fontSize: "0.9rem" }} icon={faPenToSquare} />,
            onClick: (row) => {

                const obj = {
                    order_no: row.Ord_No,
                    bill_type: 'S',
                    comp_code: compCode.join(","),
                    bal_qty: row.Bal_Qty
                };
                dispatch(setDetailParams(obj));
                dispatch(setNewEntryMode(false))
                navigate(linksUrl.salesOrder.createEntry);

            },
            type: ROW_ACTION_BTN_TYPE.button,
            color: "bg-green-600"
        },
        {
            // icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
            icon: <FontAwesomeIcon className="text-white" icon={faTrashCan} />,
            onClick: (row) => {
                if (row.status == "Pending") {
                    setItemToDelete({ orderno: row.Ord_No, billtype: 'S', compcode: compCode.join(",") })
                }
                else {
                    show(<div className="text-red-500 text-sm font-semibold">Order cannot be delete as the bill has already been generated.</div>)
                }
            },
            type: ROW_ACTION_BTN_TYPE.button,
            color: "bg-red-500"
        },
    ];


    const downloadFileHeader = { key: "f", value: "fuyergfu" }

    if (isPending) return <LoadingCard />;
    if (isError) return <ErrorCard />;

    return (
        <div>
            <MainContainer pageName="Sale Orders" breadcrumbs={["Sales", "Orderlist"]}>
                <Card>
                    <CardBody className=" py-5 mb-5" >
                        <div className="text-right mb-4 flex justify-between items-center">
                            <Select
                                size="sm"
                                label={"Show Order"}
                                color="success"
                                eventResizeFeature={true}
                                selectionMode="single"
                                labelPlacement="outside"
                                showScrollIndicators={true}
                                placeholder={"select"}
                                className="w-32  font-semibold   "
                                classNames={{
                                    label: "text-xs text-green-600 uppercase  font-bold",
                                }}
                                isClearable={true}
                                variant="flat"
                                isVirtualized

                                onChange={(e) => handleStatusChange(e.target.value)}
                                selectedKeys={[orderStatus]}
                            >

                                <SelectItem key={"Pending"}>Pending
                                </SelectItem>
                                <SelectItem key={"Final"}>Final
                                </SelectItem>
                            </Select>
                            {user?.isadmin == 1 ? "" :
                                <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
                                    New Order
                                </Button>}
                        </div>
                        <NextUITable
                            INITIAL_VISIBLE_COLUMNS={["actions", "PartyName", "Ord_No", "Ord_Date", "Ord_Qty", "Bal_Qty", "SalePerName", "status"]}
                            data={data}
                            columns={columns}
                            rowActionBtn={rowActionBtn}
                            showAdvanceFilter={false}
                            exportColumns={exportColumns}
                            downloadDataFooter={downloadDataFooter}
                            downloadFileName={`Order_List_Of_${compName[0]} ${compName.length > 1 ? "_&_Other" : ""}`}
                            //downloadFileHeader={}
                            id="Ord_No"

                        />
                    </CardBody>
                </Card>
            </MainContainer>

            {itemToDelete && itemToDelete != "" && <ConfirmBox handleConfirmBox={handleConfirmBox} />}
        </div>
    );
};

export default OrderMaster;
